export const foreignCountries = [
  '意大利',
  '伊朗',
  '韩国',
  '西班牙',
  '德国',
  '法国',
  '美国',
  '瑞士',
  '荷兰',
  '挪威',
  '英国',
  '丹麦',
  '日本本土',
  '钻石号邮轮',
  '瑞典',
  '比利时',
  '奥地利',
  '卡塔尔',
  '巴林',
  '新加坡',
  '马来西亚',
  '澳大利亚',
  '加拿大',
  '芬兰',
  '斯洛文尼亚',
  '以色列',
  '冰岛',
  '希腊',
  '捷克',
  '葡萄牙',
  '科威特',
  '阿联酋',
  '伊拉克',
  '印度',
  '埃及',
  '巴西',
  '黎巴嫩',
  '泰国',
  '爱尔兰',
  '罗马尼亚',
  '圣马力诺',
  '印度尼西亚',
  '菲律宾',
  '沙特阿拉伯',
  '波兰',
  '越南',
  '俄罗斯',
  '爱沙尼亚',
  '文莱',
  '智利',
  '阿尔巴尼亚',
  '阿根廷',
  '克罗地亚',
  '塞尔维亚',
  '巴勒斯坦',
  '巴拿马',
  '阿尔及利亚',
  '格鲁吉亚',
  '南非',
  '保加利亚',
  '秘鲁',
  '巴基斯坦',
  '哥斯达黎加',
  '斯洛伐克',
  '阿曼',
  '卢森堡',
  '阿塞拜疆',
  '厄瓜多尔',
  '匈牙利',
  '拉脱维亚',
  '墨西哥',
  '塞浦路斯',
  '波黑',
  '突尼斯',
  '白俄罗斯',
  '塞内加尔',
  '北马其顿',
  '哥伦比亚',
  '马尔代夫',
  '阿富汗',
  '摩洛哥',
  '马耳他',
  '亚美尼亚',
  '摩尔多瓦',
  '巴拉圭',
  '新西兰',
  '柬埔寨',
  '多米尼加',
  '乌克兰',
  '孟加拉',
  '立陶宛',
  '斯里兰卡',
  '哈萨克斯坦',
  '加纳',
  '喀麦隆',
  '土耳其',
  '安道尔',
  '摩纳哥',
  '尼日利亚',
  '洪都拉斯',
  '刚果（金）',
  '布基纳法索',
  '不丹',
  '加蓬',
  '多哥',
  '约旦',
  '苏丹',
  '蒙古',
  '几内亚',
  '圭亚那',
  '尼泊尔',
  '梵蒂冈',
  '肯尼亚',
  '科特迪瓦',
  '埃塞俄比亚',
  '列支敦士登公国'
]
